import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
  Router,
} from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from 'src/app/auth/auth.service';
import { FlowService } from 'src/app/flow.service';
import { UserAccess } from '../models/permission.model';
import { RoutePermissionMap } from 'src/app/shared/mappers/permission.mapper';

@Injectable({
  providedIn: 'root',
})
export class UserGuard {
  constructor(
    private auth: AuthService,
    private router: Router,
    private _flowService: FlowService
  ) {}
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    if (this.auth.isLogin()) {
      const userPermission: UserAccess = this._flowService.permission();
      const { read } = userPermission;
      const path = next.routeConfig?.path;
      const relatedPermissions = RoutePermissionMap[path || ''];
      const permissionExists = relatedPermissions?.some(
        (perm) => read?.findIndex((s: any) => s.accessKey === perm) !== -1
      );
      if (!permissionExists) {
        console.log(next.data.role);
        this.router.navigate(['dashboard/profile-details']);
        return false;
      }
      return true;
    } else {
      return false;
    }
  }
}
